import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { map, Observable } from 'rxjs';

import { Session } from '../../session';
import { SessionService } from '../../session.service';

import { AppConst } from '../../app-const';

@Injectable({
  providedIn: 'root'
})
export class LoginGuard  {

  constructor(
    private sessionService: SessionService,
    private router: Router,
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    return this.sessionService.authObservable.pipe(map((session: Session) => {
      if (!session.isLogin) {
        return true;
      } else {
        this.router.navigate([AppConst.ROUTING_LINK_TOP]);
        return false;
      }
    }))  
  }
  
}
